import { evIndustryHasForeignTradeStep } from "../../searchFlowVersionB/steps/ev/EvForeignTrade.jsx";
import GeneralError from "../../searchFlowVersionB/steps/common/GeneralError.jsx";
import KftRegActivityDescription from "../steps/KftRegActivityDescription.jsx";
import KftRegContactPage from "../steps/KftRegContactPage.jsx";
import KftRegForeignTrade from "../steps/KftRegForeignTrade.jsx";
import KftRegIndustryActivity, {
  kftRegIndustryHasActivityContent,
} from "../steps/KftRegIndustryActivity.jsx";
import KftRegIndustrySelect from "../steps/KftRegIndustrySelect.jsx";
import KftRegSuccessScreen from "../steps/KftRegSuccessScreen.jsx";
import KftRegTaxForm from "../steps/KftRegTaxForm.jsx";

/** Contact/success/error screens aren't part of the questionnaire — no progress fill there. */
const NON_PROGRESS_STEPS = new Set([KftRegContactPage, KftRegSuccessScreen, GeneralError]);

// KftRegContactPage is appended as a hidden cap (NON_PROGRESS_STEPS hides the bar once
// actually there) so the last *visible* form step never reaches 100% fill.
const buildKftRegProgressPath = (industry) => {
  const path = [KftRegIndustrySelect];
  if (kftRegIndustryHasActivityContent(industry)) {
    path.push(KftRegIndustryActivity);
  }
  path.push(KftRegActivityDescription, KftRegTaxForm);
  if (evIndustryHasForeignTradeStep(industry)) {
    path.push(KftRegForeignTrade);
  }
  path.push(KftRegContactPage);
  return path;
};

/** Raw progress fill for a step index — recomputes from the live industry value. */
export const computeKftRegFlowProgressValue = (self, stepIndex, steps) => {
  const stepComponent = steps[stepIndex]?.component;
  if (!stepComponent || NON_PROGRESS_STEPS.has(stepComponent)) {
    return null;
  }

  const industry = self.props?.company_store?.industry || "";
  const path = buildKftRegProgressPath(industry);
  const pathIndex = path.indexOf(stepComponent);
  if (pathIndex === -1) {
    return null;
  }

  const totalSteps = path.length;
  return totalSteps <= 1 ? 1 : Math.min(1, Math.max(0, (pathIndex + 1) / totalSteps));
};

/**
 * KftRegFlow progress fill, mirroring searchFlowVersionB's ASP progress bar.
 * Value is stored on the flow instance and only updated on step navigation —
 * picking an industry with more steps (e.g. one with a foreign-trade screen) while
 * still sitting on KftRegIndustrySelect must not shift the bar under the user.
 */
export const getKftRegFlowProgress = (self, activeStep, steps) => {
  const stepComponent = steps[activeStep]?.component;
  if (!stepComponent || NON_PROGRESS_STEPS.has(stepComponent)) {
    return null;
  }

  const stored = self.state?.kftRegProgressValue;
  const storedStep = self.state?.kftRegProgressStep;
  if (stored != null && storedStep === activeStep) {
    return { value: stored };
  }

  const value = computeKftRegFlowProgressValue(self, activeStep, steps);
  if (value === null) {
    return null;
  }
  return { value };
};
